export const CONTACT_EMAIL = 'hello@foam.io';
